"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _context = require("../../context");

var _fontIcon = _interopRequireWildcard(require("../font-icon"));

var _button = _interopRequireDefault(require("../button"));

var _versions = require("../../_utils/versions");

var _utilities = require("../../_utils/utilities");

var _icons;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 12px 24px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 12px 20px;\n  background-color: ", ";\n  display: grid;\n  align-items: center;\n  ", " {\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 12px;\n  margin: auto 0px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  box-sizing: border-box;\n  max-width: 1116px;\n  display: grid;\n  grid-template-columns: 64px auto 64px;\n  border: 1px solid;\n  border-color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ERROR = 'error';
var SUCCESS = 'success';
var WARNING = 'warning';
var INFO = 'info';
var CLOSE = 'close';
var ICON_SIZE = 24;
var icons = (_icons = {}, _defineProperty(_icons, ERROR, 'cross'), _defineProperty(_icons, SUCCESS, 'tick1'), _defineProperty(_icons, WARNING, 'caution'), _defineProperty(_icons, INFO, 'info'), _defineProperty(_icons, CLOSE, 'close'), _icons);

var MessageContainer = _styledComponents["default"].div(_templateObject(), function (props) {
  return (0, _utilities.validCssUnit)(props.width) && props.width;
}, function (props) {
  return (0, _versions.getColor)(props, 'message')[props.type];
}, function (props) {
  return (0, _versions.getColor)(props, 'message').background;
}, function (props) {
  return (0, _versions.getProperties)(props, 'message').radius;
}, function (props) {
  return "0 6px 8px ".concat((0, _versions.getColor)(props, 'message').shadowColor);
});

var ContentContainer = _styledComponents["default"].div(_templateObject2());

var LeftIconContent = _styledComponents["default"].div(_templateObject3(), function (props) {
  return (0, _versions.getColor)(props, 'message')[props.type];
}, _fontIcon.StyledIcon, function (props) {
  return (0, _versions.getColor)(props, 'message').iconColor;
});

var RightIcon = _styledComponents["default"].div(_templateObject4());

var getIcon = function getIcon(_ref) {
  var version = _ref.version,
      type = _ref.type;
  return _react["default"].createElement(LeftIconContent, {
    version: version,
    type: type
  }, _react["default"].createElement(_fontIcon["default"], {
    size: ICON_SIZE
  }, "icon-".concat(icons[type])));
};

var Message =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Message, _React$Component);

  function Message(props) {
    var _this;

    _classCallCheck(this, Message);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Message).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.props.onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "timeout", function () {
      _this.timeoutId = setTimeout(function () {
        _this.close();
      }, _this.props.timeout);
    });

    _this.state = {
      open: props.open
    };
    return _this;
  }

  _createClass(Message, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open !== this.props.open) {
        this.setState({
          open: nextProps.open
        });
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.timeout) {
        this.timeout();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.open) {
        return null;
      }

      return _react["default"].createElement(MessageContainer, this.props, getIcon(this.props), _react["default"].createElement(ContentContainer, null, this.props.children), _react["default"].createElement(RightIcon, null, _react["default"].createElement(_button["default"], {
        onClick: this.close,
        view: "plain"
      }, _react["default"].createElement(_fontIcon["default"], {
        size: 12
      }, "icon-".concat(icons[CLOSE])))));
    }
  }]);

  return Message;
}(_react["default"].Component);

Message.propTypes = {
  onClose: _propTypes["default"].func.isRequired,
  width: _propTypes["default"].string,
  timeout: _propTypes["default"].number,
  open: _propTypes["default"].bool
};
Message.defaultProps = {
  onClose: _noop2["default"],
  level: 'page',
  open: false
};
Message.displayName = 'Message';

var _default = (0, _context.withVersion)(Message);

exports["default"] = _default;